import styled from "styled-components";
import { inputBorderColor, loginChangeWidth } from "../../../styles/theme";

const TenantHeaderBox = styled.div`
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid ${inputBorderColor};
  display: flex;
  align-items: center;
  height: 4rem;
  padding: 0 1.5rem;
  @media only screen and (max-width: ${loginChangeWidth}) {
    padding: 0 1rem;
  }
`;

const PromoBox = styled.div`
  width: 100%;
  border: 1px solid ${inputBorderColor};
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const PromoIllustration = styled.img`
  width: 100%;
  max-width: 320px;
  border-radius: 8px;
  margin-bottom: 1rem;
`;

export { TenantHeaderBox, PromoBox, PromoIllustration };
